import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={30}
    height={30}
    fill="none"
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      stroke="var(--filter-bar-btn-border)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.868 10.5c0 .276-.276.5-.5.5h-9a.5.5 0 0 1-.5-.5c0-.276.276-.5.5-.5h9a.5.5 0 0 1 .5.5ZM15.867 13.5c0 .276-.276.5-.5.5h-8a.5.5 0 0 1-.5-.5c0-.276.277-.5.5-.5h8a.5.5 0 0 1 .5.5ZM14.368 16.5c0 .276-.277.5-.5.5h-6.5a.5.5 0 0 1-.5-.5c0-.276.276-.5.5-.5h6.5a.5.5 0 0 1 .5.5ZM12.868 19.5c0 .276-.277.5-.5.5h-5a.5.5 0 0 1-.5-.5c0-.276.276-.5.5-.5h5a.5.5 0 0 1 .5.5ZM18.05 17.024c.195-.196.549-.159.707 0l2.121 2.12a.5.5 0 0 1 0 .708c-.195.195-.549.158-.707 0l-2.121-2.121a.5.5 0 0 1 0-.707Z"
      fill="var(--filter-bar-btn-border)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 17.023c.195.196.158.55 0 .708l-2.122 2.12a.5.5 0 0 1-.707 0c-.195-.194-.158-.548 0-.706l2.121-2.122a.5.5 0 0 1 .707 0Z"
      fill="var(--filter-bar-btn-border)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.524 10c.276 0 .5.276.5.5v9a.5.5 0 0 1-.5.5c-.276 0-.5-.276-.5-.5v-9a.5.5 0 0 1 .5-.5Z"
      fill="var(--filter-bar-btn-border)"
    />
  </svg>
);

export default SvgComponent;
